const clearColors = store => async state => {
    store.setState(
        {
            ...state,
            user: {
                ...state.user,
                overrides: {
                    ...state.user.overrides,
                    primaryColor: null,
                    secondaryColor: null,
                },
            },
        },
        true,
    );
};

export default clearColors;
